import request from '@/request/request'

// 查询报警消息列表
export function listWarnRecord(query) {
    return request({
        url: '/api/equipment-server/warnRecord/list',
        method: 'get',
        params: query
    })
}

// 查询报警消息详细
export function getWarnRecordById(id) {
    return request({
        url: '/api/equipment-server/warnRecord/' + id,
        method: 'get'
    })
}

// 新增报警消息
export function addWarnRecord(data) {
    return request({
        url: '/api/equipment-server/warnRecord',
        method: 'post',
        data: data
    })
}

// 修改报警消息
export function updateWarnRecord(data) {
    return request({
        url: '/api/equipment-server/warnRecord/edit',
        method: 'post',
        data: data
    })
}

// 删除报警消息
export function delWarnRecord(id) {
    return request({
        url: '/api/equipment-server/warnRecord/delete/' + id,
        method: 'post'
    })
}

// 报警消息确认
export function actWarnRecord(data) {
    return request({
        url: '/api/equipment-server/warnRecord/act',
        method: 'post',
        data: data
    })
}
